import { Component, EventEmitter, Input, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { getOAuthProviderIcon, OAuthProvider, SUPPORTED_OAUTH_PROVIDERS_BY_PRIORITY } from '@platform-frontend/account';
import { ACCOUNT_UI_MATOMO_EVENT_CATEGORY_ACCOUNT } from '../account-ui-matomo-events';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';
import { OAuthProviderButton } from './model/o-auth-provider-button';

@Component({
  selector: 'yat-o-auth-buttons',
  templateUrl: './o-auth-buttons.component.html',
  styleUrls: ['./o-auth-buttons.component.scss'],
  providers: [provideTranslocoScope(ACCOUNT_UI_TRANSLOCO_SCOPE)]
})
export class OAuthButtonsComponent {
  @Output()
  signIn: EventEmitter<OAuthProvider> = new EventEmitter();

  @Input()
  orderedProviders: OAuthProvider[] = SUPPORTED_OAUTH_PROVIDERS_BY_PRIORITY;

  readonly providerButtons: OAuthProviderButton[] = [
    { provider: 'GITHUB', class: 'gt', tooltip: 'GitHub', tooltipClass: 'github', icon: getOAuthProviderIcon('GITHUB') },
    { provider: 'FACEBOOK', class: 'fb', tooltip: 'Facebook', tooltipClass: 'facebook', icon: getOAuthProviderIcon('FACEBOOK') },
    { provider: 'MICROSOFT', class: 'ms', tooltip: 'Microsoft', tooltipClass: 'microsoft', icon: getOAuthProviderIcon('MICROSOFT') },
    { provider: 'GOOGLE', class: 'gg', tooltip: 'Google', tooltipClass: 'google', icon: getOAuthProviderIcon('GOOGLE') },
    { provider: 'LINKEDIN', class: 'lk', tooltip: 'LinkedIn', tooltipClass: 'linkedin', icon: getOAuthProviderIcon('LINKEDIN') },
    { provider: 'APPLE', class: 'ap', tooltip: 'Apple', tooltipClass: 'apple', icon: getOAuthProviderIcon('APPLE') }
  ];

  readonly MATOMO_EVENT_CATEGORY_ACCOUNT = ACCOUNT_UI_MATOMO_EVENT_CATEGORY_ACCOUNT;

  getButton(provider: OAuthProvider): OAuthProviderButton | null {
    return this.providerButtons.find(button => button.provider === provider) ?? null;
  }

  selectProvider(provider: OAuthProvider): void {
    this.signIn.emit(provider);
  }
}
